<template>
        <ShowControl  @revert="revertClick"  :title="title" ref="showControl">
  <div style="width: 90%; margin-top: 3%;">
    <!-- <h1 style="text-align: center; margin-bottom: 10px">报表管理<span style="font-size: 25px;">(单位:元)</span></h1> -->
    <el-table :data="
          ReportFormsList.slice((currentPage - 1) * pagesize, currentPage * pagesize)"
              style="width: 100%;height: 85%;"
              empty-text="暂无数据"
              v-loading="loding"
              fit="false">
      <el-table-column prop="venueCosts"
                       label="场地费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.venueCosts).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="designCost"
                       label="设计费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.designCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="venueFees"
                       label="会场费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.venueFees).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="marketingCost"
                       label="宣传推广费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.marketingCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="attractInvestmentCost"
                       label="招商费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.attractInvestmentCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="mediaCost"
                       label="媒体费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.mediaCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="expertCost"
                       label="专家费用(含差旅)"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.expertCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="teaCost"
                       label="茶点费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.teaCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="dinCost"
                       label="正餐费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.dinCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="employeeCost"
                       label="人员成本"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.employeeCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="activityCost"
                       label="活动费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.activityCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="enterprisePurchaseCost"
                       label="企业购买费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.enterprisePurchaseCost).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="orderMaintenance"
                       label="秩序维护费用"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.orderMaintenance==null?0:scope.row.orderMaintenance).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="ticketIncome"
                       label="门票收入"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.ticketIncome).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="keynoteIncome"
                       label="主题演讲收入"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.keynoteIncome).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="smallBoothIncome"
                       label="小展位收入"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.smallBoothIncome).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="mediumBoothIncome"
                       label="中展位收入"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.mediumBoothIncome).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="largeBoothIncome"
                       label="大展位收入"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.largeBoothIncome).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
      <el-table-column prop="advertisingIncome"
                       label="广告收入"
                       align="center" min-width="50%">
                       <template #default="scope">
                          <span>{{String(scope.row.advertisingIncome).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}}</span>
                      </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="[5, 10, 15, 20]"
                   :page-size="pagesize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="ReportFormsList.length"
                   style="display: flex; justify-content: center; margin-top: 10px">
    </el-pagination>
  </div>
</ShowControl>
</template>
  <script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  data () {
    return {
      loding: false,
      caseID: localStorage.getItem("caseId"),
      currentPage: 1,
      pagesize: 10,
      ReportFormsList: [],
      ReportFormsTotal: 0,
      title: '报表管理'
    };
  },
  components: {ShowControl},
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetAllReportForms();
  },
  mounted() {
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/FinancialManagement")
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
    },
    GetAllReportForms () {
      this.loading = true
      this.$http.get('FinanceStatistics/GetAllFinance?round=' + this.Round).then((res) => {
        if (res.success) {
          this.ReportFormsList = res.dynamicObj
          this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.查看报表管理 });  
          this.loading = false
        }
      })
    }
  },
};
  </script>
  
  <style scoped>

</style>